import HtmlEditorTextarea from '@intercom/embercom-composer/components/html-editor-textarea';
export default HtmlEditorTextarea;
